import * as React from "react";
import { useRecordContext, useResourceContext } from "react-admin";
import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import { HubspotIcon } from "../icons/HubspotIcon";
import { DrivingSchool } from "../providers/drivingSchoolsProvider";
import { Instructor } from "../providers/instructorsProvider";
import { Student } from "../providers/studentsProvider";

const _hubspotBaseUrl = "https://app.hubspot.com/contacts/19951845";

export function OpenInHubspotMenuItem({ closeMenu }: { closeMenu: () => void }) {
  const resource = useResourceContext();
  const record = useRecordContext<DrivingSchool | Instructor | Student>();
  if (!record) {
    return null;
  }
  const url =
    resource === "drivingSchools"
      ? `${_hubspotBaseUrl}/company/${(record as DrivingSchool).id}/`
      : `${_hubspotBaseUrl}/contact/${(record as Instructor | Student).hubspotContactId}/`;
  return (
    <MenuItem
      onClick={() => {
        closeMenu();
        if (resource !== "drivingSchools" && !(record as Instructor | Student).hubspotContactId) {
          showErrorToast(`Keine HubSpot-Kontakt-ID für ${record.name} hinterlegt.`);
        } else {
          open(url, "_blank");
        }
      }}
    >
      <ListItemIcon>
        <HubspotIcon sx={{ fontSize: 20 }} />
      </ListItemIcon>
      <ListItemText>In HubSpot öffnen</ListItemText>
    </MenuItem>
  );
}
